import { type GridColDef } from "@mui/x-data-grid";
import moment from "moment";

import { Organization } from "api/memberPortal/orgs/orgs.types";
import { Product } from "api/memberPortal/project/product/product.types";
import { dataGridDateOnlyGetter } from "components/MUI/DataGrid/DataGrid.utils";

import PidActionsCell from "./cells/PidActions.cell";

interface buildPidColumnsProps {
  setProduct: (_product: Product) => void;
  setShowDeleteModal: (_show: boolean) => void;
  handleShowProductFormModal: (_product: Product) => void;
  setProductDelete: (_product: Product) => void;
}

const buildPidColumns = ({
  setProduct,
  setShowDeleteModal,
  handleShowProductFormModal,
  setProductDelete,
}: buildPidColumnsProps): GridColDef<Product>[] => {
  return [
    {
      headerName: "VID",
      field: "v_id",
      flex: 0,
      maxWidth: 70,
      align: "center",
    },
    {
      headerName: "Vendor",
      field: "vendor_id",
      valueGetter: (value: Organization) => value?.name ?? "",
      flex: 2,
    },
    { headerName: "Product", field: "product_name", flex: 3 },
    {
      headerName: "Type",
      field: "submission_type",
    },
    {
      headerName: "Date",
      field: "draft_date",
      type: "date",
      valueGetter: dataGridDateOnlyGetter,
      valueFormatter: (value) =>
        value ? moment.utc(value).format("MM/DD/YYYY") : "Pending",
      flex: 2,
    },
    {
      headerName: "",
      field: "actions",
      sortable: false,
      renderCell: ({ row }) => (
        <PidActionsCell
          product={row}
          handleShowProductFormModal={handleShowProductFormModal}
          setShowDeleteModal={setShowDeleteModal}
          setProduct={setProduct}
          setProductDelete={setProductDelete}
        />
      ),
      flex: 0,
      maxWidth: 50,
      align: "center",
    },
  ];
};

export default buildPidColumns;
